<template>
    <div class="main-section">
    <div class="content">

        <div class="navigation-bar">
            <div class="navigation-bar-menus">
                <ul>
                    <!-- <li><a class="sidebar-active">setup</a></li> -->
                    <li><router-link to="contacts">Contacts</router-link></li>
                    <!-- <li><router-link to="customforms">Custom Forms</router-link></li> -->
                    <li><router-link to="autoresponse">Auto Response</router-link></li>
                    <!-- <li><router-link to="campaign">Campaign</router-link></li> -->
                    <li><router-link to="bulksms" class="sidebar-active">BulkMan 1.2</router-link></li>
                </ul>
            </div>
        </div>
        <!-- eo page navigation bar -->

        <div class="main-content">

            <div id="bulkman" class="campaign-log setbulk-sms content-here">
                <el-card>
                <page-bulkman></page-bulkman>
                </el-card>
            </div>
            <!-- eo bulkman -->

        </div>
        <!-- end of main content -->

    </div>

    <div class="footer">
        <p>© ekghanti 2020</p>
    </div>

    </div>
</template>


<script>
import bulkman from '../parts/bulkman.vue'

export default {
    components: {
        'page-bulkman': bulkman
    }
}
</script>


// WEBPACK FOOTER //
// src/components/views/subpages/bulksms.vue